


















import CUserAccessTogglesModal from '~/components/shared/configurable/access-toggle/CUserAccessTogglesModal.vue'
import { faUserLock } from '@fortawesome/free-solid-svg-icons'
import { AccessToggleIdentifier } from '~/models/user/access-toggles'
import { defineComponent, PropType } from '@nuxtjs/composition-api'

export default defineComponent({
  components: { CUserAccessTogglesModal },
  props: {
    identifier: {
      type: [String, Number] as PropType<AccessToggleIdentifier>,
      required: true
    },
    userDisplayName: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      showAccessTogglesModal: false
    }
  },
  computed: {
    icons: () => ({
      accessToggles: faUserLock
    })
  },
  methods: {
    openAccessTogglesModal() {
      this.$emit('click')
      this.showAccessTogglesModal = true
    }
  }
})
